import React from 'react'
import Navbar from '../../components/navbar';
import LogoutModel from '../../components/Models/LogoutModel';
import Footer from '../../components/footer';
import Sidebar from '../../components/sidebar';
import FancyEditForm from './FancyEditForm';


const FancyEdit = () => {
  return (
    <div>
      {/* Page Wrapper */}
      <div id="wrapper">
        {/* Sidebar */}
        <Sidebar />
        {/* Content Wrapper */}
        <div id="content-wrapper" className="d-flex flex-column">
          {/* Main Content */}
          <div id="content">
            {/* Topbar */}
            <Navbar navTitle={"Fancy Market"}/>
            {/* Begin Page Content */}
            <FancyEditForm />
            {/* /.container-fluid */}
          </div>
          {/* Footer */}
          <Footer />
        </div>
      </div>
      {/* Scroll to Top Button*/}
      <a className="scroll-to-top rounded" href="#page-top">
        <i className="fas fa-angle-up" />
      </a>
      {/* Logout Modal*/}
      <LogoutModel />
    </div>
  )
}

export default FancyEdit;
